import { RootState } from '../../rootReducer';

export const jobsSelectors = {
  getAsyncJobs: (state: RootState) => state.JobsState.asyncJobs,
  getJobs: (state: RootState) => state.JobsState.jobs,
};
